import dayjs from 'dayjs'
import { ShippingAddress } from '../typings/base'
import { ORDER_ITEM_TYPE, ORDER_STATE } from './constants'

//get order informations
export const getOrderInformations = (
  order: any,
  index: number,
  numberOfOrders: number
) => {
  let state: string
  const orderStartLeasingDate: string = order.startLeasingDate
  const orderEndLeasingDate: string = order.endLeasingDate
  const isCancelled: boolean = order.shippingState === ORDER_STATE.CANCELLED
  const shippingAddress: ShippingAddress = order.shippingAddress
  const currentDate = dayjs()
  const startLeasingDate = dayjs(order.startLeasingDate, 'DD/MM/YYYY')
  const endLeasingDate = dayjs(order.endLeasingDate, 'DD/MM/YYYY')
  const checkoutCompletedAt = dayjs(order.checkoutCompletedAt).format(
    'DD/MM/YYYY'
  )
  const lastOrder: boolean = index + 1 === numberOfOrders
  const isCancellable: boolean = order.isCancellable
  const tokenValue: string = order.tokenValue
  const cancelledAt = order.cancelledAt
  const shipments = order.shipments
  const total = order.totals?.total

  if (isCancelled) {
    state = ORDER_STATE.CANCELLED
  } else {
    if (currentDate.diff(startLeasingDate, 'day') <= 0) {
      state = ORDER_STATE.COMING
    } else if (currentDate.diff(endLeasingDate, 'day') <= 0) {
      state = ORDER_STATE.RETURN
    } else {
      state = ORDER_STATE.FINISHED
    }
  }
  const rentalOrderList: any = order.items.filter(
    (item) => item.type === ORDER_ITEM_TYPE.RENTAL
  )
  const secondHandOrderList: any = order.items.filter(
    (item) => item.type === ORDER_ITEM_TYPE.SECOND_HAND
  )
  return {
    orderNumber: order.number,
    rentalOrderList,
    secondHandOrderList,
    isCancelled,
    state,
    orderStartLeasingDate,
    orderEndLeasingDate,
    shippingAddress,
    checkoutCompletedAt,
    lastOrder,
    isCancellable,
    tokenValue,
    cancelledAt,
    shipments,
    total,
  }
}
